export default "__VITE_ASSET__DVIE8L0N__"